import { FormattedMessage } from 'react-intl'

import { BankEligibilityBeneficialOwner } from '@/domains/Business/types'
import { StatusBadge, StatusVariant } from '@/shared/components'

const badgeVariantByDocumentStatus: Record<string, StatusVariant> = {
  NOT_STARTED: 'neutral',
  COMPLETED: 'active',
}

type Props = {
  owner: BankEligibilityBeneficialOwner
}

export const OwnerVerificationStateCell = ({ owner }: Props) => {
  const status = owner.document ? 'COMPLETED' : 'NOT_STARTED'

  return (
    <div className="flex items-center">
      <StatusBadge
        variant={badgeVariantByDocumentStatus[status]}
        title={
          <FormattedMessage
            id="verification.status.label"
            defaultMessage="{status, select, NOT_STARTED {Not started} IN_PROGRESS {In progress} COMPLETED {Completed} REJECTED {Rejected} other {}}"
            values={{ status }}
          />
        }
      />
    </div>
  )
}
